module.exports = __webpack_public_path__ + "static/media/org.8743685f.mp3";